import { render } from "./InvoiceTabs.vue?vue&type=template&id=2c9be966"
import script from "./InvoiceTabs.vue?vue&type=script&lang=js"
export * from "./InvoiceTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__